export const iconMapper = status => {
    switch (status) {
        case 'INVALID':
        case 'ERROR':
            return 'status-error'
        case 'SUCCESS':
            return 'status-check'
        case 'PENDING_CHALLENGE_RESPONSE':
        case 'PENDING_SIGNATURE':
        case 'PROCESSING':
        case 'PENDING':
        default:
            return 'status-clock'
    }
}

export const iconMapperDetailTable = status => {
    switch (status) {
        case '2':
        case '3':
        case '5':
        case 'ERROR':
            return 'error'
        case '0':
        case '1':
            return 'check'
        case '-1':
        default:
            return 'clock'
    }
}

export const iconColorMapperDetailTable = status => {
    switch (status) {
        case '2':
        case '3':
        case '5':
        case 'ERROR':
            return 'negative'
        case '0':
        case '1':
            return 'positive'
        case '-1':
        default:
            return 'warning'
    }
}

export const iconColorMapper = status => {
    switch (status) {
        case 'INVALID':
        case 'ERROR':
            return 'negative'
        case 'SUCCESS':
            return 'positive'
        case 'PENDING':
        case 'PENDING_CHALLENGE_RESPONSE':
        case 'PENDING_SIGNATURE':
        case 'PROCESSING':
        default:
            return 'warning'
    }
}

export const iconModalMapper = status => {
    switch (status) {
        case 'PENDING':
            return 'status-line-pending'
        case 'PENDING_CHALLENGE_RESPONSE':
            return 'status-line-pending'
        case 'PENDING_SIGNATURE':
            return 'status-line-pending'
        case 'PROCESSING':
            return 'status-line-pending'
        case 'SUCCESS':
            return 'status-line-success'
        case 'ERROR':
            return 'status-line-error'
        case 'INVALID':
            return 'status-line-error'
    }
}

export const colorStatusMapperModal = status => {
    switch (status) {
        case 'SUCCESS':
            return 'var(--positive)'
        case 'INVALID':
        case 'ERROR':
            return 'var(--negative)'
        case 'PENDING':
        case 'PENDING_CHALLENGE_RESPONSE':
        case 'PENDING_SIGNATURE':
        case 'PROCESSING':
        default:
            return 'var(--warning)'
    }
}
